<template>
  <template v-if="checkoutStore.ui.loading.isStep3ShippingLoading">
    <div
      class="w-full motion-safe:animate-pulse motion-reduce:animate-none"
      role="status"
    >
      <div class="flex justify-start items-center">
        <div class="w-128 h-16 bg-text-disabled"></div>
      </div>
      <div class="flex justify-start items-center mt-16">
        <div class="w-28 h-28 rounded-full bg-text-disabled"></div>
        <div class="w-60 h-16 ml-16 bg-text-disabled"></div>
        <div class="w-96 h-16 ml-16 bg-text-disabled"></div>
      </div>
      <div class="flex justify-start items-center">
        <div class="w-180 h-96 rounded-md bg-text-disabled mt-16"></div>
      </div>

      <div class="flex justify-start items-center mt-16">
        <div class="w-28 h-28 rounded-full bg-text-disabled"></div>
        <div class="w-96 h-16 ml-16 bg-text-disabled"></div>
        <div class="w-60 h-16 ml-16 bg-text-disabled"></div>
      </div>
      <div class="flex justify-start items-center">
        <div class="w-200 h-96 rounded-md bg-text-disabled mt-16"></div>
      </div>
    </div>
  </template>
  <template v-else>
    <InputRadioGroup legend="Leverans">
      <InputRadioWithContent
        v-for="method in checkoutStore.fetchedData.shippingOptions"
        :key="method.Name"
        v-model="checkoutStore.userState.selectedDeliveryMethod"
        :value="method"
        :label="method.Name"
        :group-name="STEP3_SHIPPING_METHODS_RADIO_GROUP"
        :validate-on-value-update="false"
      >
        <template
          v-if="
            method.Name == checkoutStore.userState.selectedDeliveryMethod?.Name
          "
          #visible
        >
          <div v-if="method.ServicePoints?.length">
            <div
              class="flex flex-col gap-8 lockers-container w-full md:w-300 p-16 border-md rounded-md border-border-secondary"
            >
              <div>
                <p class="body-bold-md">
                  {{
                    method.ServicePoints.filter(
                      (lockers: ShippingLockers) => lockers.Selected,
                    )[0]?.Name
                  }}
                </p>
                <p class="body-bold-md">
                  {{
                    method.ServicePoints.filter(
                      (lockers: ShippingLockers) => lockers.Selected,
                    )[0]?.Time
                  }}
                </p>
              </div>
              <p>
                {{
                  method.ServicePoints.filter(
                    (lockers: ShippingLockers) => lockers.Selected,
                  )[0]?.Description
                }}
              </p>
              <button
                v-if="method.ServicePoints.length > 1"
                class="underline w-fit body-link-md text-text-link hover:text-text-link-hover"
                type="button"
                lang="sv"
                aria-label="Byt upphämtningsplats"
                @click="changeLocker(method)"
              >
                Ändra
              </button>
            </div>
          </div>
          <div v-if="method.Name.includes('Instabox')" class="w-full md:w-300">
            <InputText
              v-model="checkoutStore.userState.inputtedInstaboxPhoneNumber"
              label="Telefonnummer"
              :name="STEP3_SHIPPING_INSTABOX_PHONE_NUMBER"
              :input-id="STEP3_SHIPPING_INSTABOX_PHONE_NUMBER"
              placeholder="0701234567"
              mode="eager"
              :validate="['phoneNumberNotEmpty', 'phoneNumberCorrectFormat']"
              help-text="Ange ditt telefonnummer för Instabox-avisering"
            />
          </div>
        </template>
        <template #img>
          <NuxtImg
            :src="method.IconUrl"
            :alt="`Logga för ${method.Name}`"
            class="h-32 w-32"
            loading="lazy"
            :provider="
              method.IconUrl?.includes('cloudfront') ? 'cloudfront' : undefined
            "
          />
        </template>
      </InputRadioWithContent>
    </InputRadioGroup>
    <AppModal v-model="showInstaLockerModal" dialog-titel="Välj pickup box">
      <InputRadioGroup>
        <InputRadioWithContent
          v-for="locker in ServicePointReference?.ServicePoints"
          :key="locker.Name"
          v-model="selectedLockerName"
          :value="locker.Name"
          :label="locker.Name"
          :group-name="STEP3_SHIPPING_METHODS_LOCKER_RADIO_GROUP"
          :validate-on-value-update="false"
          @update:model-value="updateValue(locker.Name)"
        >
          <template #visible> </template>
        </InputRadioWithContent>
      </InputRadioGroup>
    </AppModal>
  </template>
</template>

<script lang="ts" setup>
import {
  STEP3_SHIPPING_INSTABOX_PHONE_NUMBER,
  STEP3_SHIPPING_METHODS_RADIO_GROUP,
  STEP3_SHIPPING_METHODS_LOCKER_RADIO_GROUP,
} from '~/models/checkout/forms/Step3Form.model';
import type {
  ShippingMethod,
  ShippingLockers,
} from '~/repository/modules/ShippingMethod.module';

const updateValue = (name: string) => {
  if (!name) {
    return;
  }

  ServicePointReference.value?.ServicePoints.forEach((servicePoint) => {
    if (servicePoint.Name == name) {
      servicePoint.Selected = true;
    } else {
      servicePoint.Selected = false;
    }
  });
  showInstaLockerModal.value = false;
};
const showInstaLockerModal = ref(false);
const ServicePointReference = ref<ShippingMethod>();
const selectedLockerName = ref<string>();
const checkoutStore = useMyCheckoutStore();

const changeLocker = (method: ShippingMethod) => {
  ServicePointReference.value = method;
  selectedLockerName.value =
    method.ServicePoints.find((x) => x.Selected)?.Name ??
    method.ServicePoints[0].Name;
  showInstaLockerModal.value = true;
};
</script>

<style scoped lang="scss">
.lockers-container {
  box-shadow: inset 0.6rem 0rem 0 0 $blue-500;
}
</style>
